<!-- <div class="modal-header">
<h5 class="modal-title">Content Details</h5>
<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>

</div>
<div class="modal-body">
  <pre *ngIf="data as d">{{ d | json }}</pre>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="activeModal.close()">Close</button>
</div> -->



<div class="gmmappin-modal">
  <button class="close-button"><img src="assets/icons/icon-close.svg" alt="" (click)="activeModal.close()"></button>
  <div class="gmmappin-body">
    <div class="gm-img">
      <img [src]="data.image_url ?  data.image_url : 'assets/images/game1.png'" alt="">
    </div>
    <ul>
      <li class="title"><span>Title:</span> <span>{{data.content_title}}</span></li>
      <li><span>Type:</span> <span>{{data.type}}</span></li>
      <!-- <li><span>Recommended Players:</span> <span>{{data.recommend_player}}</span></li> -->
      <li><span>Recommended Party Level:</span> <span>{{data.partyaverage}}</span></li>
      <li class="description-container"><span>Description:</span> <span class="description-text">{{data.description}}</span></li>
      <li><span>Price:</span> <span>{{data.cost || 'Free'}}</span>
      @if (data.access_type) {
        <span class="status-chip" [ngClass]="data.access_type?.toLowerCase() === 'creator' ? 'owned' : 'purchased'">
          {{ data.access_type?.toLowerCase() === 'creator' ? 'Selling' : 'Purchased' }}
        </span>
      }
    </li>
    @if (!data.access_type) {
      <li class="d-flex align-items-center w-100 justify-content-center">
        <button class="btn btn-dark btn-sm" (click)="goToCheckoutWP(data)">Purchase</button>
      </li>
    }
    @if (data.access_type && data.access_type?.toLowerCase() === 'purchase') {
      <li class="d-flex align-items-center justify-content-center">
        <button class="btn btn-dark btn-sm" (click)="goToDownloadPage()">Download</button>
      </li>
    }
  </ul>
</div>
<div class="btn-wrapper">
  <button type="button" class="btn btn-green  custom-font-size" (click)="navigateToContentPage()">Content page</button>
  @if (!isFavoriteLoading) {
    @if (!data.favorited) {
      <button type="button" class="btn btn-green  custom-font-size" (click)="markThisContentToFavorite()"
      >Save to favorites</button>
    }
    @if (data.favorited) {
      <button type="button" class="btn btn-dark  custom-font-size" (click)="markThisContentToFavorite()"
      >Remove from Favorites</button>
    }
  }

  @if (isFavoriteLoading) {
    <button type="button" class="btn btn-dark custom-font-size" disabled>
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Loading...
    </button>
  }
</div>
</div>